import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class OcrComparisonRepository {
  constructor(private apiService: ApiService) {}

  public entrySummaryReport(entrySummaryIds: number[]): Observable<Blob> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/management/entry-summaries/ocr-comparison/report`,
      { entrySummaryIds },
      { responseType: 'blob' },
    );
  }

  public isfComparison(isfId: number, includeAll: boolean = false): Observable<object> {
    return this.apiService.get(`${environment.url.isfManagement}${isfId}/ocr-comparison`, { params: { includeAll } });
  }
}
